<template>
    <div>
      <div v-if="status=='credit'">
        <font-awesome-icon icon="money-check-dollar" />
      </div>
      <div v-else-if="status=='wallet'">
        <font-awesome-icon icon="sack-dollar" />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data(){
      return{
        
      }
    },
    props: {
      status:{
        type:String,
        default:""
      } 
    },
    methods:{
  
    },
    computed:{
  
    },
    watch:{
  
    },
    components: {
     
    },
  };
  </script>
  
  <style>
  
  </style>